import React from "react";
import Navbar from "../../../components/main/navbar";
import Footer from "../../../components/main/footer";
import { Grid2, Typography, Card, CardContent, Button } from "@mui/material";
import Logo from "../../../images/icon.png";
const Demo = () => {
  return (
    <div>
      <Navbar />
      <Grid2
        container
        justifyContent="space-evenly"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
        bgcolor="#f8f9fc"
        flexDirection="column"
      >
        <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
          <Typography variant="body2" fontWeight="700" fontSize="30px">
            Presentation
          </Typography>
        </Grid2>

        <iframe
          width="100%"
          height="400px"
          src="https://www.youtube.com/embed/Bf396oJktWY"
          title="SmartCandidate"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            maxWidth: "1000px",
            borderRadius: "8px",
          }}
        ></iframe>
      </Grid2>

      <Grid2
        container
        justifyContent="space-evenly"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
        bgcolor="#f8f9fc"
        flexDirection="column"
      >
        <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
          <Typography variant="body2" fontWeight="700" fontSize="30px">
            Tutoriels
          </Typography>
        </Grid2>

        <Grid2 gap={2} width="100%">
          {" "}
          <Grid2
            container
            justifyContent="center"
            width="100%"
            flexDirection="column"
          >
            <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
              <Typography variant="h5" fontSize="20px">
                Comment installer SmartCandidate
              </Typography>
            </Grid2>
            <Grid2
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid2 width="80%" maxWidth="1000px">
                <iframe
                  width="100%"
                  height="300px"
                  src="https://www.youtube.com/embed/n0ARzaqduUY"
                  title="Comment installer SmartCandidate"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "8px" }}
                ></iframe>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent="center"
            width="100%"
            flexDirection="column"
          >
            <Grid2
              textAlign="center"
              alignItems="center"
              marginBottom="20px"
              marginTop="20px"
            >
              <Typography variant="h5" fontSize="20px">
                Comment générer une lettre de motivation
              </Typography>
            </Grid2>
            <Grid2
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid2 width="80%" maxWidth="1000px">
                <iframe
                  width="100%"
                  height="300px"
                  src="https://www.youtube.com/embed/iGHVN9MicDY"
                  title="Comment générer une lettre de motivation"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "8px" }}
                ></iframe>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent="center"
            width="100%"
            flexDirection="column"
          >
            <Grid2
              textAlign="center"
              alignItems="center"
              marginBottom="20px"
              marginTop="20px"
            >
              <Typography variant="h5" fontSize="20px">
                Comment recharger vos crédits 💵
              </Typography>
            </Grid2>
            <Grid2
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid2 width="80%" maxWidth="1000px">
                <iframe
                  width="100%"
                  height="300px"
                  src="https://www.youtube.com/embed/FIUHYJTEaEQ"
                  title="Comment recharger vos crédits"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "8px" }}
                ></iframe>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent="center"
            width="100%"
            flexDirection="column"
          >
            <Grid2
              textAlign="center"
              alignItems="center"
              marginBottom="20px"
              marginTop="20px"
            >
              <Typography variant="h5" fontSize="20px">
                Comment corriger le fichier de CV manquant 📝
              </Typography>
            </Grid2>
            <Grid2
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid2 width="80%" maxWidth="1000px">
                <iframe
                  width="100%"
                  height="300px"
                  src="https://www.youtube.com/embed/5b4rn1N3Xi4"
                  title="Comment corriger le fichier de CV manquant"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "8px" }}
                ></iframe>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2
            container
            justifyContent="center"
            width="100%"
            flexDirection="column"
          >
            <Grid2
              textAlign="center"
              alignItems="center"
              marginBottom="20px"
              marginTop="20px"
            >
              <Typography variant="h5" fontSize="20px">
                Comment corriger la reconnexion 🔄
              </Typography>
            </Grid2>
            <Grid2
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid2 width="80%" maxWidth="1000px">
                <iframe
                  width="100%"
                  height="300px"
                  src="https://www.youtube.com/embed/tRcpI4Pkm_c"
                  title="Comment corriger la reconnexion"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    borderRadius: "8px",
                  }}
                ></iframe>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>

      <Grid2
        container
        bgcolor="#f8f9fc"
        flexDirection="column"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
      >
        <Grid2 marginBottom="20px">
          <Typography variant="body2" fontWeight="700" fontSize="30px">
            Badges
          </Typography>
        </Grid2>
        <Grid2 container flexDirection="row" gap={3} padding="30px">
          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
                cursor: "auto",
              },
            }}
          >
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                CV manquant 📝
              </Typography>
              <Typography variant="body2" color="inherit">
                Si vous voyez cette notification, cela signifie que vous n'avez
                pas encore téléchargé votre CV. Veuillez le télécharger pour
                permettre à SmartCandidate de générer une lettre de motivation
                personnalisée pour vous
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
                cursor: "auto",
              },
            }}
          >
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Reconnexion 🔄
              </Typography>
              <Typography variant="body2" color="inherit">
                Si vous voyez ce badge, cela signifie que vous devez vous
                reconnecter via l'interface de l'extension pour continuer à
                utiliser SmartCandidate. Veuillez vous connecter pour
                continuer{" "}
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              maxWidth: 325,
              transition: "transform 0.3s ease",
              "&:hover": {
                boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
                cursor: "auto",
              },
            }}
          >
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Facturation 💵
              </Typography>
              <Typography variant="body2" color="inherit">
                Si vous voyez ce badge, cela signifie que vous avez atteint
                votre limite d'utilisation pour SmartCandidate. Veuillez
                recharger votre plan pour continuer{" "}
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>
      <Grid2
        container
        bgcolor="#f8f9fc"
        flexDirection="column"
        flexWrap="wrap"
        padding="30px"
        justifyContent="space-evenly"
      >
        <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
          <Typography variant="body2" fontWeight="700" fontSize="30px">
            SmartCandidate
          </Typography>
        </Grid2>

        <Grid2
          container
          bgcolor="#f8f9fc"
          flexDirection="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="space-evenly"
        >
          <Grid2>
            <img src={`${Logo}`} height="150px" width="175px" alt="logo" />
          </Grid2>

          <Grid2 maxWidth="500px">
            {" "}
            <Typography variant="body2" marginBottom="10px">
              🌟 Présentation de SmartCandidate: Votre Partenaire Professionnel!
            </Typography>
            <Typography variant="body2" marginBottom="10px">
              🌟 Nous sommes ravis de lancer officiellement SmartCandidate, une
              solution révolutionnaire conçue pour simplifier et améliorer vos
              candidatures professionnelles!
            </Typography>
            <Typography variant="body2" marginBottom="10px">
              🚀 🎯 Qu'est-ce que SmartCandidate? SmartCandidate vous aide à
              créer des lettres de motivation sur mesure en quelques clics.
              Téléchargez simplement votre CV, sélectionnez une description de
              poste, et laissez SmartCandidate rédiger une lettre personnalisée
              qui met en valeur vos forces et correspond parfaitement au poste.
            </Typography>
            <Typography variant="body2" marginBottom="10px">
              💡 Pourquoi choisir SmartCandidate? Générez des lettres de
              motivation professionnelles En Anglais, Français, ou Espagnol.
              Gagnez du temps en créant des candidatures impactantes.
              Distinguez-vous avec un contenu qui reflète vos compétences
              uniques et votre expérience.
            </Typography>
            <Typography variant="body2" marginBottom="10px">
              💬 Nous aimerions entendre vos commentaires ! Qu'est-ce qui vous
              pose problème le plus lors de la candidature à des postes ?
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 textAlign="center">
          {" "}
          <Button
            type="submit"
            href="/contact-us"
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              width: "300px",
              fontWeight: "700",
              color: "white",
              backgroundColor: "#146aff",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                color: "white",
                backgroundColor: "#004aad",
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            Contact
          </Button>
        </Grid2>
      </Grid2>
      <Footer />
    </div>
  );
};

export default Demo;
